var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebtrials(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.803,
    height: 42,
    viewBox: "0 0 42.803 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x30_3_Content_Curation",
    transform: "translate(-1.137 -5.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(1.137 5.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M38.1,34.941v-5.6a.671.671,0,0,0-.669-.669H23.207V25.157a9.644,9.644,0,1,0-1.338,0v3.511H7.644a.666.666,0,0,0-.669.669v5.6a6.5,6.5,0,1,0,1.338,0V30.006H21.87v4.936a6.5,6.5,0,1,0,1.338,0V30.006H36.764v4.936a6.507,6.507,0,1,0,1.338,0ZM12.807,41.415a5.166,5.166,0,1,1-5.163-5.17A5.171,5.171,0,0,1,12.807,41.415Zm14.894,0a5.166,5.166,0,1,1-5.163-5.17A5.171,5.171,0,0,1,27.7,41.415ZM22.538,23.853a8.3,8.3,0,1,1,8.3-8.3A8.313,8.313,0,0,1,22.538,23.853Zm13.8,14.707a.669.669,0,1,1,1.337,0V38.8a.669.669,0,1,1-1.337,0Zm4.942,5.25a.669.669,0,0,1-.93-.14l-1.572-2.127-1.077,1.465a.669.669,0,0,1-.542.274.656.656,0,0,1-.535-.274l-.562-.749-1.043,1.424a.669.669,0,1,1-1.077-.8l1.585-2.153a.659.659,0,0,1,1.07,0l.562.756,1.083-1.471a.668.668,0,0,1,.535-.268.681.681,0,0,1,.542.268l2.107,2.856a.673.673,0,0,1-.147.936Z",
    transform: "translate(-1.137 -5.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M55.968,400.014a1.471,1.471,0,0,1-.622,1.2l-1.632,1.15a1.47,1.47,0,0,1-2.321-1.2v-2.3a1.47,1.47,0,0,1,2.321-1.2l1.632,1.15A1.474,1.474,0,0,1,55.968,400.014Z",
    transform: "translate(-47.173 -364.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M225.781,404.324a.669.669,0,0,0,.669.669h3.733a.669.669,0,1,0,0-1.337H226.45A.669.669,0,0,0,225.781,404.324Z",
    transform: "translate(-206.917 -370.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M228.316,437.686H226.45a.669.669,0,1,0,0,1.337h1.866a.669.669,0,1,0,0-1.337Z",
    transform: "translate(-206.917 -401.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M215.548,83.285a.669.669,0,0,0-.946,0l-4.5,4.5-1.336-1.336a.669.669,0,0,0-.946.946l1.809,1.809a.669.669,0,0,0,.946,0l4.973-4.973A.669.669,0,0,0,215.548,83.285Z",
    transform: "translate(-190.285 -76.608)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebtrials);
export default __webpack_public_path__ + "static/media/Webtrials.c215b40bd8f13628545b6208ad607090.svg";
export { ForwardRef as ReactComponent };